// extracted by mini-css-extract-plugin
export var closeButton = "_lm-1";
export var closeX = "_lm-3";
export var container = "_lm-0";
export var image = "_lm-2";